// import Vue from 'vue'
// import './plugins/vuetify'
// import App from './App.vue'
// import router from './router'
// import store from './store'
//
// Vue.config.productionTip = false
//
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// /* eslint no-extend-native: "off" */
// if (!Object.prototype.values) {
//   Object.prototype.values = function () {
//     return Object.keys(this).map(function (k) {
//       return this[k]
//     })
//   }
// }
// /* eslint import/first: "off" */
// import values from 'object.values'

import 'babel-polyfill' // Needed by IE on windows mobile
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router'
import Vuetify from 'vuetify'
import App from '@/App'
import '@/assets/stylus/main.styl'
import { t } from '@/i18n'
import dal from '@/data'
import './registerServiceWorker'

Vue.use(Vuetify, {
  theme: {
    primary: '#2196f3', // blue
    secondary: '#e0e0e0', // grey lighten-2
    subtitle: '#BDBDBD', // grey lighten-1
    accent: '#69f0ae' // green accent-2
  }
})
Vue.config.productionTip = false

Vue.component('btn_', require('./components/widget/Button.vue').default)

/* eslint-disable no-new */
const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.config.errorHandler = function (err, vm, info) {
  emailError(err, info, null, null, null)
  console.error(err, info, vm)
}

// Window operations
if (window) {
  dal.config.onVersion(data => {
    store.commit('config/version', data)
    if (store.state.config.reload) {
      window.location.reload(true)
    }
  })

  window.onerror = function (msg, url, line, col, error) {
    emailError(msg, url, line, col, error)
    // If you return true, then error alerts (like in older versions of
    // Internet Explorer) will be suppressed.
    return false
  }
}

function emailError (msg, url, line, col, error) {
  if (!error) return
  const user = vue.$store.getters.currentUser.displayName

  const mailOptions = {
    from: t('Email from'),
    to: 'jacek.p.kolodziejczyk@gmail.com',
    subject: 'Cell app error',
    html: `<p>user: ${user}</p>` +
      `<p>msg: ${msg}</p>` +
      `<p>url: ${url}</p>` +
      `<p>line: ${line}</p>` +
      `<p>col: ${col}</p>` +
      `<p>error: ${error}</p>` +
      `<p>stack: ${error.stack}</p>`
  }
  dal.mailer.create(mailOptions)
}
